export default "__VITE_ASSET__DKNyTZUU__"